import {useUniversalFetch} from '#imports';
import {extractLink} from '~/helpers/api/ExtractLinkHelper';
import type {MissionPreferencesResource} from '~/types/api-raw-types';
import {MissionPreferences} from '~/types/domain/MissionPreferences';
import type {Profile} from '~/types/domain/Profile';
import type {MissionPreferencesRepository} from '~/types/domain/repository/MissionPreferencesRepository';

async function fetchMissionPreferences(profile: Profile): Promise<MissionPreferences> {
    const url = extractLink(profile.locationPreferences.links, 'missionPreferences');
    const missionPrefrencesResource = await useUniversalFetch<MissionPreferencesResource>(url);
    return new MissionPreferences(missionPrefrencesResource);
}

export const missionPreferencesRepository: MissionPreferencesRepository = {
    fetchMissionPreferences,
};
